// extracted by mini-css-extract-plugin
module.exports = {"root":"Decorations_root__f4mz_","ref":"Decorations_ref__ATbwq","layout":"Decorations_layout__iOGMW","title":"Decorations_title__Sspvc","rotation":"Decorations_rotation__rIv_m"};